import React from 'react';
import {useLocation} from 'react-router-dom';
import {Hero,Action,Section,Cards,Closing,inquiry} from '@/components/Marketing';
import {DeliveryRows,Questions,ServiceRail} from '@/components/Editorial';
import {useDocumentMeta} from '@/lib/useDocumentMeta';
import {SEO_ROUTES} from '@/lib/seo';
import searchContent from '@/lib/search-content.json';
import ModelingPage from '@/components/ModelingPage';


export default function Capability() {
  const {pathname: currentPath} = useLocation();
  const pathname = currentPath.replace(/\/+$/, "") || "/";
  const page = searchContent.landingPages[pathname];
  useDocumentMeta(SEO_ROUTES[pathname]);
  if (pathname === '/construction-models-takeoffs-cut-fill') return <ModelingPage page={page}/>;
  return <div className="forge-site" data-testid="capability-page">
    <Hero eyebrow={page.eyebrow} title={page.title} accent={page.accent} body={page.summary} image={page.image}>
      <Action to={inquiry(page.interest)}>{page.cta}</Action>
    </Hero>
    <ServiceRail/>
    {page.capabilityCards && <Section eyebrow="Modeling & Takeoff Capabilities" title="The Right Data for the Way You Build." body={page.capabilityIntro}><Cards items={page.capabilityCards}/></Section>}
    <DeliveryRows eyebrow="Define the Need. Agree on the Work." title="A Clear Scope from the First Conversation." rows={page.sections}/>
    <Questions items={page.faqs}/>
    <Section dark eyebrow="Explore the Related Capabilities" title="Build the Right Engagement.">
      <Cards items={page.related.map(([to,title]) => ({to,title,link:"Explore this capability",body:SEO_ROUTES[to].description}))}/>
    </Section>
    <Closing title="Bring Us the Work You Need Done." body="Tell us your requirements and preferred timing. We’ll review the scope, agree on pricing, and schedule the right next step." interest={page.interest}/>
  </div>;
}

